/**
 * File index.js
 *
 * Main theme functions.
 */

 jQuery(document).ready(function($){
    var $win = $(window),
        $doc = $(document),
        $html = $("html"),
        $body = $("body"),
        $header = $body.find("#shopify-section-header"),
        $nav = $header.find("nav"),
        $navBtn = $header.find(".hero__btn"),
		$footer = $body.find("#shopify-section-footer"),
        $siteContent = $body.find(".wrapper"),
        $main = $siteContent.find(".main"),
        isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
        events = eventsObj();
    var winWidth = $win.width(),
        winHeight = $win.height(),
        docHeight = $doc.height(),
        scrollY = $win.scrollTop();
    
    
    //-----------------------------------------------------------------------
    //-- MODULES
    //-----------------------------------------------------------------------
    var modules = {
        //---------------------------------
        //-- PAGES
        //---------------------------------
        homePage: function() {
            if (!$body.hasClass("template-index")) { return; }
          
          	subscribe();
          
          
            function subscribe() {
              var $sec = $(".section-subscribe"),
                  $form = $sec.find("form");

              subscribeFormScrollTo();
              
              function subscribeFormScrollTo() {
                  if (location.search.includes("customer_posted")) {
                      $html.add($body).animate({
                          scrollTop: $sec.offset().top
                      }, 1000);
                  }
              }
            }
        },
        productPages: function() {
            if (!$body.hasClass("template-product")) { return; }
            var jQueryZoomUrl = "//cdn.shopify.com/s/files/1/0550/9192/1053/t/2/assets/jQueryZoom.js?v=12765501454049967912";

            loadScript(jQueryZoomUrl, productZoom);

            function productZoom() {//console.log("productZoom");
                var $sec = $main.find(".product__images"),
                    $images = $sec.find(".product__slider").find("picture").addClass("test");//cl("test",$images.length);

                setTimeout(function() {
                    $images.zoom();
                }, 2000);
            }
        },
        //---------------------------------
        //-- COMMON SECTIONS
        //---------------------------------
        steamAnimationSections: function() {
            var $sec = $main.find(".steam-video-section");
            if (!$sec.length) { return; }
          	
          
          	gsap.timeline({
              scrollTrigger: {
                trigger: $sec,
                onEnter: steamAnimation
              }
            });
          
          	function steamAnimation() {//console.log("steam animation start");
            	var $video = $sec.find("video"),
                    src = $video.find("source").data("src");
              
              	if (!isMobile) {
              		$video.find("source").attr("src", src).removeAttr("data-src").end().get(0).load();
                }
                else { $video.remove(); }
          	}
        },
      	animateText: function() {
        	//hero();
          	previewSection();
          	featuredProducts();
          	subscribe();
          	productPage();
          
          	function hero() {
            	var $hero = $main.find(".hero");
              
              	$hero
                	.attr("data-scrolltrigger",`{
                      "animation": "fadeIn.fromRight",
                      "distance": "20%",
                      "duration": "1.5",
                      "trigger": "$this.closest('.shopify-section')",
                      "start": "top 70%",
                      "clearProps": "false",
                      "onComplete": "$this.closest('.shopify-section').addClass('animation-complete');",
                      "splittext": "{target:'.hero__title',type:'words'}",
                      "target": ".word",
                      "stagger": "0.15"
					}`);
          	}
          	function previewSection() {
            	var $sec = $main.find(".section-preview");
              
              	$sec
                	.attr("data-scrolltrigger",`{
                      "animation": "fadeIn.fromBottom",
                      "distance": "50%",
                      "duration": "1.5",
                      "trigger": "$this.closest('.shopify-section')",
                      "start": "top 70%",
                      "clearProps": "false",
                      "onComplete": "$this.closest('.shopify-section').addClass('animation-complete');",
					  "splittext": "{target:'.section__title p',type:'words'}",
                      "target": ".word, .inline-img",
                      "stagger": "0.05"
					}`);
              
              //Products/Recipes
              if (mq("(max-width: 1023px)")) {
                $sec
                  .find(".image-text").attr("data-scrolltrigger", `{
                        "animation": "fadeIn",
                        "distance": "5%",
                        "duration": "0.5",
                        "onComplete": "$this.addClass('is-visible')"
                      }`);
              }
              else {
                $sec
                  .find(".section__aside").attr("data-scrolltrigger", `{
                        "animation": "fadeIn",
                        "distance": "5%",
                        "duration": "0.5",
						"onComplete": "$this.find('.image-text').addClass('is-visible')",
						"stagger": "0.15"
                      }`);
              }
              
         	}
          	function featuredProducts() {
            	var $sec = $main.find(".section-featured-products");
              
              	//MOBILE
              	if (mq("(max-width: 1023px)")) {
                  $sec.find(".product-item")
                      .attr("data-scrolltrigger",`{
                        "animation": "fadeIn.fromBottom",
                        "distance": "20%",
                        "duration": "1.5",
                        "start": "top 70%",
                        "clearProps": "false",
                        "onComplete": "$this.closest('.shopify-section').addClass('animation-complete');",
                        "target": "picture.product-item__image img"
                      }`);
            	}
          		//DESKTOP
          		else {
            		$sec
                      .attr("data-scrolltrigger",`{
                        "animation": "fadeIn.fromBottom",
                        "distance": "20%",
                        "duration": "1.5",
                        "start": "top 70%",
                        "clearProps": "false",
                        "onComplete": "$this.closest('.shopify-section').addClass('animation-complete');",
                        "target": ".img-cnt",
						"stagger": "0.15"
                      }`);
          		}
          	}
          	function subscribe() {
            	var $sec = $main.find(".section-subscribe");
              
              /*setTimeout(function() {
              	$sec
                .attr("data-scrolltrigger", `{
                          "animation": "fadeIn.fromBottom",
                          "distance": "30%",
						  "duration": ".5",
                          "splittext": "{target: '.section__title', type: 'lines', wrapLines: true}",
                          "stagger": "0.15",
                          "target": ".line"
						}`
                      );
              }, 2000);*/
          	}
          
          	
          	function productPage() {
            	var $sec = $main.find(".product-recipe");
              
              	$sec
                	.attr("data-scrolltrigger",`{
                      "animation": "fadeIn.fromBottom",
                      "distance": "50%",
                      "duration": "1.5",
                      "start": "top 70%",
                      "clearProps": "false",
                      "onComplete": "$this.addClass('animation-complete');",
					  "splittext": "{target:'.product-recipe__title',type:'words'}",
                      "target": ".word",
                      "stagger": "0.05"
					}`);
              
              //Products/Recipes
              if (mq("(max-width: 1023px)")) {
                $sec
                  .find(".image-text").attr("data-scrolltrigger", `{
                        "animation": "fadeIn",
                        "distance": "5%",
                        "duration": "0.5",
                        "onComplete": "$this.addClass('is-visible')"
                      }`);
              }
              else {
                $sec
                  .find(".product-recipe__aside").attr("data-scrolltrigger", `{
                        "animation": "fadeIn",
                        "distance": "5%",
                        "duration": "0.5",
						"onComplete": "$this.find('.image-text').addClass('is-visible')",
						"stagger": "0.15"
                      }`);
              }
              
         	}
      	},
        stampedProductReviews: function() {
          const $sec = $main.find(".section-testimonials");
          const $template = $main.find("#testimonial-template");
          if (!$template.length) return;
          
          getReviews()
          .then(data => {
            let html = '';
            data.data.forEach(review => {console.log("review",review);
              let template = $template.html();
              let ratingsHTML = '<div class="ratings">';
              template = template.replace(/{{ quote }}/g, review.reviewMessage);
              template = template.replace(/{{ author }}/g, review.author);
              for (var i=0;i < review.reviewRating;i++) {
                ratingsHTML += '<i class="stamped-fa stamped-fa-star"></i>';
              }
              ratingsHTML += '</div>';
              template = template.replace('<div class="ratings"></div>', ratingsHTML);
              html += template;
            });
            $sec.find(".testimonials").html(html);
          });

          
          function getReviews() {
            // Docs for reference: https://developers.stamped.io/#da27f990-cabd-4882-864a-7b8f9dd55832
            const settings = {
              url: "https://stamped.io/api/widget/reviews",
              method: "GET",
              timeout: 0,
              CORS: true ,
              headers: {
                'Access-Control-Allow-Origin': '*',
              },
              data: {
                storeUrl: "low-and-slow-snacks-1.myshopify.com",
                apiKey: "pubkey-tp19WU6k838RDz2r1Q0404w9eBvT48",
                //sortReviews: //featured, highest-rating, lowest-rating, photos, most-votes
                minRating: 5,//1 - 5, filter reviews with minimum rating
              }
            };
            return new Promise((resolve,reject) => {
              $.ajax(settings).done(data => {
                resolve(data);
              });
            });
          }
        },
        //---------------------------------
        //-- SITE
        //---------------------------------
        navTrigger: function() { return; //Use if needed
            $navBtn.on("click", toggleMenu);
            $nav.find(".close-btn").on("click", closeMenu);            
            $win.resize(closeMenu);
            events.on("scroll_to_link_click", closeMenu);
            
            function toggleMenu() {
                $navBtn.toggleClass("active");
                $nav.toggleClass("open", $navBtn.hasClass("active"));
                $body.toggleClass("nav-open", $navBtn.hasClass("active"));
                $.scrollLock($navBtn.hasClass("active"));
            }
            function closeMenu() {
                $navBtn.removeClass("active");
                $nav.removeClass("open");
                $body.removeClass("nav-open");
                $.scrollLock(false);
            }
        },
        modalTrigger: function() { return; //Use if neeeded
            var $modal = $(".modal");
            
            $modal.appendTo($body);
            $doc.on("click", ".js-modal-trigger", openModal);
            $doc.on("click", ".modal .close-btn", closeModal);
            $win.on("resize", closeModal);
            
            function openModal() {
                var $target = $(`.modal${$(this).attr("data-target")}`);
                if (!$target.length) { cl(`no modal target: ${$(this).attr("data-target")}`); return; }
                    
               	$target.addClass("open");
                $body.addClass("modal-open");
                $.scrollLock(true);
            }
            function closeModal() {
                $(".modal").removeClass("open");
                $body.removeClass("modal-open");
                $.scrollLock(false);
            }
        },
        slickHeroSliders: function() { return;//use if needed
            var $slider = $(".page-header-section").find(".slick-slider");
            if (!$slider.length) { return; }
            
            $slider.slick({
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: pI($slider.attr("data-autoplay-speed")),
                speed: 500,
                fade: true,
                cssEase: 'linear',
                lazyLoad: 'ondemand',
                lazyLoadSrcAttr: 'data-lazy',
                lazyLoadSrcsetAttr: 'data-srcset',
            });
        },
        lazyIframeOEmbed: function() { return;//oembed
            var $oEmbedIframe = $main.find("iframe.lazy-oembed");
            if (!$oEmbedIframe.length) { return; }
            
            $oEmbedIframe.each(loadIframe);
                
            function loadIframe() {
                var $this = $(this),
                    videoSrc = getSrc($this.attr("data-src"));
                
                $this
                .attr("frameborder","0")
                .attr("allowfullscreen", "")
               	.attr("src", videoSrc);
            }
            function getSrc(url) {
                var embedObj = parseVideo(url);
                
                switch(embedObj.type) {
                    case "vimeo":
                        return `//player.vimeo.com/video/${embedObj.id}?autoplay=1&autopause=0`;
                    	break;
                    case "youtube":
                        return `//www.youtube.com/embed/${embedObj.id}?autoplay=1`;
                        break;
                    default:
                        return url;
                }
            }
        },
      	vimeoModals: function() { return;//Use with Magnific Popup
        	var $videoSections = $main.find(".section-video");
          	if (!$videoSections.length) { return; }
          	
          	loadScript('https://player.vimeo.com/api/player.js', init);
          
          	function init() {//cl("video vimeo init");
                $videoSections.find(".js-video-popup").on('mfpOpen', function(e) {
                	playVideo();
                });
          	}
          	function playVideo() {cl("play video");
            	var $modal = $(".mfp-container"),
                    $iframeVid = $modal.find(".mfp-iframe"),
                    player = new Vimeo.Player($iframeVid[0]);//cl("player play", player);
              
              	player.play();
          	}
      	},
        scrollToLinks: function() { return;//Use if needed
            var $scrollToLinks = $('a[href^="#"], a[href^="/#"]').not(".no-scrollto");

            $scrollToLinks.on("click", function(e) {
                var href = $(this).attr("href").replace("/", ""),
                    $section = $(href);

                if (href == "#") { e.preventDefault(); }
                if ($section.length) {
                    e.preventDefault();
                    events.emit("scroll_to_link_click");
                    $html.add($body).animate({
                        scrollTop: $section.offset().top
                    }, 1000);
                }
            });
        },//scrollToLinks()
      	scrollTriggerAnimation() { //use with gsap
          	init();//events.on("vendors_js_loaded", init);
            
          	function init() {
            	var $items = $main.find(`[data-scrolltrigger]`);
              	$items.each(setScrollTrigger);
          	}
      	},
      	vendorAssets: function() { return; //Use if needed
            var themeDir = "/wp-content/themes/red-designs";
            
          	events.on("window_loaded", loadVendors);
        	events.on("window_loaded", loadCSSHelpers);
                                  
          	function loadCSSHelpers() {
                var assetUrl = `${themeDir}/js/css-helper-classes.js`;

                loadScript(assetUrl, callback);

                function callback() {
                    events.emit("css_helper_classes_js_loaded");
                }
            }
            function loadVendors() {
                var assetUrl = `${themeDir}/js/vendors.js`;

                loadScript(assetUrl, callback);

                function callback() {
                    events.emit("vendors_js_loaded");
                }
            }
      	},
        //---------------------------------
        //-- GLOBAL
        //---------------------------------
        window: function() {
            //-- Scroll
            var ticking = false;
            $win.on("scroll", handleScrolling);
            function handleScrolling(e) {
                if (!ticking) {
                    window.requestAnimationFrame(function() {
                        updateScrollPos();
                        ticking = false;
                    });
                    ticking = true;
                }
            }
            function updateScrollPos() {
                var scrollTop = $win.scrollTop();
                if (scrollY == scrollTop) { return; }//only update if scroll position has changed
                scrollY = scrollTop;
                events.emit("scrollYChanged");
            }

            //-- Resize
            $win.on("resize", checkVariables);
            function checkVariables() {
                if (winWidth != $win.width()) {
                    updateWidth();
                }
                if (winHeight != $win.height()) {
                    updateHeight();
                }
            }
            function updateWidth() {
                winWidth = $win.width();
                events.emit("winWidthChange");
            }
            function updateHeight() {
                winHeight = $win.height();
                events.emit("winHeightChanged");
            }
          
          	//-- Load
          	$win.on("load", function() {
            	events.emit("window_loaded");
          	});
        },//window()
        document: function() {
            //-- Document Height
            $win.on("resize", updateDocHeight);
            events.on("elHeightChange", updateDocHeight);
            function updateDocHeight() {
                var newDocHeight = $doc.height();
                if (newDocHeight != docHeight) {
                    docHeight = newDocHeight;
                    events.emit("docHeightChanged", docHeight);
                }
            }
        },//document()
        body: function() {
            var atTopVal = 0,
                lastScrollY = scrollY;

            setup();
            events.on("scrollYChanged", updateScrollClasses);

            function setup() {
                 //== Initial setup
                (scrollY <= atTopVal) ? $body.addClass("at-top") : $body.removeClass("at-top");
                ((scrollY + winHeight) == docHeight) ? $body.addClass("at-bottom") : $body.removeClass("at-bottom");
                $body.addClass("ready");
                events.emit("siteReady");
            }
            function updateScrollClasses() {
                //If scrolling up or down
                (lastScrollY > scrollY) ? $body.removeClass("scrolling-down").addClass("scrolling-up") : $body.addClass("scrolling-down").removeClass("scrolling-up");
                //If at top of page
                (scrollY <= atTopVal) ? $body.removeClass("scrolling-down").removeClass("scrolling-up").addClass("at-top") : $body.removeClass("at-top");
                //If at bottom of page
                ((scrollY + winHeight + 1) >= docHeight) ? $body.addClass("at-bottom") : $body.removeClass("at-bottom");//console.log("scrollTop + windowHeight:", (scrollTop + winHeight + 1))
                //Update lastScrollY var
                lastScrollY = scrollY;
            }
        },//body()
    };


    //-----------------------------------------------------------------------
    //-- HELPER FUNCTIONS
    //-----------------------------------------------------------------------
    //-- Scroll Trigger Animations with GSAP --//
    function setScrollTrigger() {//cl("scrollTrigger->this",this);
    	var $this = (this instanceof jQuery === false) ? $(this) : (this.length === 1) ? this : this.first(),
            settings = (typeof($this.data("scrolltrigger")) === "string") ? { animation:$this.data("scrolltrigger") } : $this.data("scrolltrigger");
        if (!$this.data("scrolltrigger") || $this.data("scrolltrigger") == "") { return; }//cl("settings:",settings);

      
      	//Init
      	if (settings.splittext) { addSplitText(); }//TODO
      	var $target = getTarget();
        setup();
        var animation = getAnimationObj(settings);//cl("scrollTrigger->Animation:", animation);
      	if (settings.init) { runFunction("init"); }
        if (settings.animation == ("fromTo")) {
            //TODO: gsap.fromTo($target, { getFrom() }, { getTo() });
        }
        else {
            gsap.from($target, animation);
        }
        
      
      	//Functions
        function getAnimationObj(settings) {
            var obj = {
                duration: settings.duration,
                delay: settings.delay,
              	ease: settings.ease,
                stagger: settings.stagger,
                scrollTrigger: {
                    trigger: settings.trigger,
                    start: settings.start,
                    end: settings.end,
                    scrub: settings.scrub,
                  	once: settings.runOnce,
                    markers: settings.markers
                },
              	onComplete: onComplete
            };
            
          	//Fade
            if (settings.animation.includes("fadeIn")) {
                obj.autoAlpha = 0;
            }
          	//Animation
          	if (settings.animation.includes(".from")) {
              	setAnimation();
          	}
          	//ScrollTrigger Callbacks
          	setSTCallbacks();
          	
            return obj;
          
          	//Callbacks
          	function setSTCallbacks() {
          		var setLazyLoad = (settings.lazyload && settings.lazyload == "true");
              
            	if (settings.onEnter || settings.onEnterBack || setLazyLoad) {
                    if (settings.onEnter || setLazyLoad) {
                        obj.scrollTrigger.onEnter = function() {
                          if (setLazyLoad) {
                            $this.find("img").each(lazyLoad);
                          }
                          if (settings.onEnter) { runFunction("onEnter"); }
                        }
                    }
                    if (settings.onEnterBack || setLazyLoad) {
                      	obj.scrollTrigger.onEnterBack = function() {
                          if (setLazyLoad) { //*Note: lazy load is placed onEnter && onEnterBack to ensure it gets called in either direction
                            $this.find("img").each(lazyLoad);
                          }
                          if (settings.onEnterBefore) { runFunction("onEnterBefore"); }
                        }
                    }
                }
                if (settings.onLeave) {
                  	obj.scrollTrigger.onLeave = function() {
                		runFunction("onLeave");
                	}
                }
                if (settings.onLeaveBack) {
                  	obj.scrollTrigger.onLeaveBack = function() {
                		runFunction("onLeaveBack");
                	}
                }
                if (settings.onUpdate) {
                    $this.append(`<div class="progress-updater" style="display:none;"></div>`);
                    var $progress = $this.find(".progress-updater");
                  	obj.scrollTrigger.onUpdate = function(progress) {//cl("progress", progress);
                    	var progObj = { progress: progress.progress, direction: progress.direction, isActive: progress.isActive };
                        $progress.html(JSON.stringify(progObj));
                    	runFunction("onUpdate");
                	}
                }
          	}
          	//Animation
          	function setAnimation() {
          		var _animation = settings.animation.split(".")[1],
                    distance = (settings.distance) ? getDistance(settings) : false;//cl("distance:",distance);
              
              	if (_animation == "fromLeft" || _animation == "fromRight" || _animation == "fromTop" || _animation == "fromBottom") {
                	var transitionProperty,
                        transitionValue;
                  
                  	transitionProperty = (_animation == "fromLeft" || _animation == "fromRight") ? "x" : "y";
                  	if (distance != false && settings.distance.includes("%")) {
                    	transitionProperty += 'Percent';
                    }
                    
                  	transitionValue = (distance != false) ? pI(distance) : (_animation == "fromLeft" || _animation == "fromTop") ? -100 : 100;
                  
                  	obj[transitionProperty] = transitionValue;
                }
              	//FromTo (TODO)
              	else if (settings.animation == ("fromTo")) {
                	//Must use settings.fromTo
              	}
          	}
          	function onComplete() {
            	if ($target.attr("data-transition")) { gsap.set($target, { clearProps: "transition" }); }
                if (settings.clearProps && settings.clearProps === "true") { gsap.set($target, { clearProps: true }); }
                if (settings.onComplete) {
                  runFunction("onComplete");
                }
          	}
        }
      	function setup() {
        	settings.duration = getDuration();
            settings.start = (settings.start) ? settings.start : "top 80%";
            settings.end = (settings.end) ? settings.end : "bottom top";
            settings.ease = (settings.ease) ? settings.ease : "power4";
            settings.delay = (settings.delay) ? settings.delay : 0;
            settings.animation = (settings.animation) ? settings.animation : "fadeIn";
            settings.scrub = (settings.scrub) ? settings.scrub : false;
            settings.trigger = (settings.trigger) ? getTrigger() : $target;
            settings.stagger = (settings.stagger) ? (settings.stagger.includes("{")) ? eval(`(${settings.stagger})`) : settings.stagger : 0;
            settings.runOnce = (settings.runOnce) ? (settings.runOnce == "true") : true;
            settings.markers = (settings.markers) ? (settings.markers == "true") : false;
            settings.splittext = (settings.splittext) ? settings.splittext : false;
      	}
      	function addSplitText() {
            var _settings = eval(`(${settings.splittext})`),
                _$this = $this.find(_settings.target);
            if (_settings == "") { return; }//cl("text animation: ", settings);
            //Split text
            _settings.type = (_settings.type) ? _settings.type : "words";
            _settings.charsClass = (_settings.charsClass) ? _settings.charsClass : "char splitText-item";
            _settings.wordsClass = (_settings.wordsClass) ? _settings.wordsClass : "word splitText-item";
            _settings.linesClass = (_settings.linesClass) ? _settings.linesClass : "line splitText-item";
            //Animation
            _settings.duration = (_settings.duration) ? pI(_settings.duration) : 1;
            _settings.start = (_settings.start) ? _settings.start : "top bottom";
            _settings.end = (_settings.end) ? _settings.end : "bottom top";
            _settings.toggleActions = (_settings.toggleActions) ? _settings.toggleActions : "play reset resume reset";

            var textSplit = new SplitText(_$this, { type: _settings.type, charsClass: _settings.charsClass, wordsClass: _settings.wordsClass, linesClass: _settings.linesClass });
            //Custom wrapper elements
            if (_settings.wrapChars) { wrapChars(_$this); }
            if (_settings.wrapWords) { wrapWords(_$this); }
            if (_settings.wrapLines) { wrapLines(_$this); }
        }
        function getDuration() {
          var duration = (settings.duration),
              curTransVal = $target.css("transition");
          if (duration && settings.duration != "null") {
              duration = pF(settings.duration);
              //Check if has transition value already set. If so remove temporarily and re-set during onComplete
              if (!curTransVal.includes("all 0s")) {
                  $target.css("transition", "initial").attr("data-transition", curTransVal);
              }
          }
          else {
              //Check if has no transition value is set. If not then set duration to 1s.
              if (curTransVal.includes("all 0s")) {
                  duration = 1.5;//Default
              }
              //else if $target has transition set transition to that
              else {
                  var curTD = $target.css("transitionDuration").split("s")[0];
                  duration = curTD;
                  $target.css("transition", "initial").attr("data-transition", curTransVal);
              }
          }
          return duration;
        }
      	function getDistance(settings) {//checks if distance is set properly
        	var distance = settings.distance,
                animation = settings.animation;
          	if (animation.includes("Left") || animation.includes("Top")) {
              	if (pI(distance) > 0) {//cl("old distance:",distance);
                	distance = (distance.includes("%")) ? `${pI(distance) * -1}%` : distance * -1;//cl("new distance:",distance);
              	}
          	}
          	return distance;
      	}
      	function getTrigger() {
        	var trigger = settings.trigger;
            //Run a function that returns an element Ex: trigger:"$this.parent()" || "$this.closest("section")
          	if (trigger.includes("$")) {
                trigger = eval(trigger);
            }
          	return trigger;
      	}
      	function getTarget() {
        	var $target = $this;
          	if (settings.target) {
            	if (settings.target.includes("$")) {
                	$target = eval(settings.target);
                }
                else { $target = $this.find(settings.target); }
          	}
          
          	return $target;
      	}
      	function runFunction(settingFn) {
        	try { eval(settings[settingFn]); }
          	catch(err) { cl(`strolltrigger ${settingFn} ERROR`, err); }
      	}
    }
  	//-- Lazy Load --//
  	function lazyLoad() {
  		var $this = $(this),
            src = (this.getAttribute("data-src")) ? this.dataset.src : false,
            srcset = (this.getAttribute("data-srcset")) ? this.data.srcset : false;
      
      	if (!src) { return; }
      	if (srcset != false) { $this.attr("srcset",srcset); }
      	$this.attr("src",src).removeAttr("data-src").removeAttr("data-srcset").addClass("js-loaded");
  	}
    //-- Load External Script --//
    function loadScript(url, callback = false) {
        var script = document.createElement("script");

        script.type = "text/javascript";
        //IE
        if (script.readyState){
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" || script.readyState == "complete"){
                    script.onreadystatechange = null;
                    onload();
                }
            };
        }
        else {
            script.onload = function(){
                onload();
            };
        }
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);

        function onload() {
            if (callback != false) { callback(); }
        }
    }
    //-- Load External Stylesheet --//
    function loadStyle(url, callback = false) {
        var style = document.createElement("link");

        style.rel = "stylesheet";
        //IE
        if (style.readyState){
            style.onreadystatechange = function(){
                if (style.readyState == "loaded" || style.readyState == "complete"){
                    style.onreadystatechange = null;
                    onload();
                }
            };
        }
        else {
            style.onload = function(){
                onload();
            };
        }
        style.href = url;
        document.getElementsByTagName("head")[0].appendChild(style);

        function onload() {
            if (callback != false) { callback(); }
        } 
    }
  	//-- Text Wrap Helpers --//
    function wrapLines($this) {
        var $lines = $this.find(".line.splitText-item");
        $lines.each(wrap);
        function wrap() {
            $(this).wrap('<div class="line-wrap"></div>');
        }
    }
    function wrapWords($this) {
        var $words = $this.find(".word.splitText-item");
        $words.each(wrap);
        function wrap() {
            $(this).wrap('<div class="word-wrap"></div>');
        }
    }
    function wrapChars($this) {
        var $chars = $this.find(".char.splitText-item");
        $chars.each(wrap);
        function wrap() {
            $(this).wrap('<div class="char-wrap"></div>');
        }
    }
    //-- Events Object Setup --//
    function eventsObj() {
        return {
            events: {},
            on: function(eventName, fn) {
                this.events[eventName] = this.events[eventName] || [];
                this.events[eventName].push(fn);
            },
            off: function(eventName, fn) {
                if (this.events[eventName]) {
                    for (var i = 0; i < this.events[eventName].length; i++) {
                        if (this.events[eventName][i] === fn) {
                            this.events[eventName].splice(i, 1);
                            break;
                        }
                    };
                }
            },
            emit: function(eventName, data) {
                if (this.events[eventName]) {
                    this.events[eventName].forEach(function(fn) {
                        fn(data);
                    });
                }
            }
        };
    }
    //-- Console Log Shortcut --//
    function cl($arg1, $arg2 = "empty bruh") {
        return ($arg2 == "empty bruh") ? console.log($arg1) : console.log($arg1, $arg2);
    }
    //-- Media Matches Shortcut --//
    function mq(mediaQuery) {
        switch (mediaQuery) {
            case "phone": mediaQuery = "(max-width: 767px), screen and (max-width: 812px) and (orientation: landscape)"; break;
            case "not phone": mediaQuery = "(min-width: 768px)"; break;
            case "tablet": mediaQuery = "(max-width: 1023px)"; break;
            case "desktop": mediaQuery = "(min-width: 1024px)"; break;
            case "portrait": mediaQuery = "(orientation: portrait)"; break;
            case "landscape": mediaQuery = "(orientation: landscape)"; break;
            default: mediaQuery = mediaQuery;
        }
        mediaQuery = (!mediaQuery.includes("(") && !mediaQuery.includes(")")) ? `(${mediaQuery})` : mediaQuery;//if forget to put ()
        return window.matchMedia(mediaQuery).matches;
    }
    //-- Detect Mobile Devices --//
    function mobileDevice(device) {
        var deviceCheck;
        switch(device) {
            case 'android':
                deviceCheck = /Android/i.test(navigator.userAgent);
                break;
            case 'iOS':
                deviceCheck = /iPhone|iPad|iPod/i.test(navigator.userAgent);
                break;
            default:
                deviceCheck = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        };
        return deviceCheck;
    }
    //-- Parse Int Shortcut --//
    function pI(int) {
        return parseInt(int);
    }
    //-- Parse Float Shortcut --//
    function pF(int) {
        return parseFloat(int);
    }
    //-- GetBoundingClientRect Shortcut --//
    function getBound(el) {//takes dom obj or jquery obj
        var node = (typeof el === "string") ? document.querySelector(el) : (el instanceof jQuery) ? el[0] : el;
        return node.getBoundingClientRect();
    }
    //-- JSON String --//
    function isJson(str) {
        try { JSON.parse(str); }
        catch(err) { return false; }
        return true;
    }
    //-- jQuery Shuffle Method (need to call before use) --//
    function $shuffle() {
        //-- Shuffle an array of jQuery elements --//
        $.fn.shuffle = function() {
            var allElems = this.get(),
                getRandom = function(max) {
                    return Math.floor(Math.random() * max);
                },
                shuffled = $.map(allElems, function(){
                    var random = getRandom(allElems.length),
                        randEl = $(allElems[random]).clone(true)[0];
                    allElems.splice(random, 1);
                    return randEl;
               });

            this.each(function(i){
                $(this).replaceWith($(shuffled[i]));
            });

            return $(shuffled);
        };
    }
    //-- Check if el in viewport --//
    function isInViewport(el) {
        var bounding = el.getBoundingClientRect(),//console.log("el",el);console.log("bounding",bounding);
            isVisible = (
            //Y Axis
            (
                (bounding.top >= 0 && bounding.top <= winHeight)
                ||
                (bounding.bottom >= 0 && bounding.bottom <= winHeight)
            )
        );//console.log("isVisible",isVisible);
        return isVisible;
    }
    //-- Get scroll position as percentage (how far scrolled down page) --//
    function getScrolledPercent(round = false) {
        var scrollableLength = docHeight - winHeight,
            scrollFraction = scrollableLength / 100,
            scrolledAmount = scrollY / scrollFraction;//cl(`scrolled percent: ${scrolledAmount}`);
        return (round) ? Math.round(scrolledAmount) : scrolledAmount;
    }
    //-- Get Scroll Element Trigger Point --//
    function getScrollTriggerPoint($el, triggerOffset = 0, triggerHook = "onEnter") {
        var offset = $el.offset(),
            screenOffset = getScreenOffset(),
            scrollTriggerPoint = offset.top;

        //Screen Offset
        scrollTriggerPoint-=screenOffset;
        //Trigger Offset
        scrollTriggerPoint = (typeof triggerOffset === "number") ? scrollTriggerPoint + triggerOffset : scrollTriggerPoint;

        return (scrollTriggerPoint > 0) ? scrollTriggerPoint : 0;

        function getScreenOffset() {
            var hookOffset;
            if (typeof triggerHook === "string") {
                switch(triggerHook) {
                    case "onCenter":
                        hookOffset = winHeight / 2;
                        break;
                    case "onLeave":
                        hookOffset = 0;
                        break;
                    default://"onEnter"
                        hookOffset = winHeight;
                }
            }
            else {
                hookOffset = (typeof triggerHook === "number" && triggerHook <= 1 && triggerHook >= 0) ? triggerHook * winHeight : winHeight;
            }
            return hookOffset;
        }
    }
    //-- Get oEmbed Video Type and ID --//
    function parseVideo(url) {
        //https://gist.github.com/yangshun/9892961
        url.match(/(https?:\/\/|\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/);

        if (RegExp.$3.indexOf('youtu') > -1) {
            var type = 'youtube';
        } else if (RegExp.$3.indexOf('vimeo') > -1) {
            var type = 'vimeo';
        }

        return {
            type: type,
            id: RegExp.$6
        };
    }
    //-- Get oEmbed video thumbnail --//
    function getVideoThumbnail (url, cb) {
        // Obtains the video's thumbnail and passed it back to a callback function.
        var videoObj = parseVideo(url);
        if (videoObj.type == 'youtube') {
            cb('//img.youtube.com/vi/' + videoObj.id + '/maxresdefault.jpg');
        } else if (videoObj.type == 'vimeo') {
            // Requires jQuery
            $.get('http://vimeo.com/api/v2/video/' + videoObj.id + '.json', function(data) {
                cb(data[0].thumbnail_large);
            });
        }
    }
    function decodeHTMLSpecialChars(string) {
        return string.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '\"');
    }
	/**
 	* scrolllock.js
 	* https://gist.github.com/barneycarroll/6550066
 	*/
	$.scrollLock=function(){"use strict";var $=jQuery,l=$("html"),o=!1,t={scrollLeft:$(window).scrollLeft(),scrollTop:$(window).scrollTop()},s={},c={"overflow-y":"scroll",position:"fixed",width:"100%"};function r(){var o,t=l.attr("style"),c={};t&&(o=t.split(/;\s/),$.each(o,function(l){if(l){var o=l.split(/\s:\s/);o.length<2||(c[o[0]]=o[1])}}),$.extend(s,c))}function n(){var s={};o||(t={scrollLeft:$(window).scrollLeft(),scrollTop:$(window).scrollTop()},r(),$.extend(s,c,{left:-t.scrollLeft+"px",top:-t.scrollTop+"px"}),l.css(s),$(window).scrollLeft(0).scrollTop(0),o=!0)}function e(){o&&(l.attr("style",$("<x>").css(s).attr("style")||""),$(window).scrollLeft(t.scrollLeft).scrollTop(t.scrollTop),o=!1)}return r(),function(l){arguments.length?l?n():e():o?e():n()}}();


    //-----------------------------------------------------------------------
    //-- INIT
    //-----------------------------------------------------------------------
    $.each(modules, function() { this(); });
    

}); // document ready
